/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from '@servicetitan/application-data/common-interfaces';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IBrandApi {
    getData(cancelToken?: CancelToken): AxiosPromise<BrandDataModel>;
    findCompanyByEin(ein: string, country: string, cancelToken?: CancelToken): AxiosPromise<BrandModel>;
    submit(model: BrandModel, cancelToken?: CancelToken): AxiosPromise<BrandModel>;
}

export const BASE_URL_TOKEN_BrandApi = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class BrandApi implements IBrandApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@inject(BASE_URL_TOKEN_BrandApi) @optional() private readonly baseUrl = "") {
    }

    getData(cancelToken?: CancelToken): AxiosPromise<BrandDataModel> {
        let url_ = "/app/api/Brand/GetData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<BrandDataModel>(options_));
    }

    findCompanyByEin(ein: string, country: string, cancelToken?: CancelToken): AxiosPromise<BrandModel> {
        let url_ = "/app/api/Brand/FindCompanyByEin?";
        if (ein === undefined || ein === null)
            throw new Error("The parameter 'ein' must be defined and cannot be null.");
        else
            url_ += "ein=" + encodeURIComponent("" + ein) + "&";
        if (country === undefined || country === null)
            throw new Error("The parameter 'country' must be defined and cannot be null.");
        else
            url_ += "country=" + encodeURIComponent("" + country) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<BrandModel>(options_));
    }

    submit(model: BrandModel, cancelToken?: CancelToken): AxiosPromise<BrandModel> {
        let url_ = "/app/api/Brand/Submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = model;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<BrandModel>(options_));
    }
}

export interface BrandDataModel {
    brandModel?: BrandModel | undefined;
    countriesWithStates?: { [key: string]: string[]; } | undefined;
}

export interface BrandModel {
    status: BrandStatus;
    message?: string | undefined;
    dbaName?: BrandModelFieldOfString | undefined;
    legalName?: BrandModelFieldOfString | undefined;
    ein?: BrandModelFieldOfString | undefined;
    phone?: BrandModelFieldOfString | undefined;
    streetAddress?: BrandModelFieldOfString | undefined;
    city?: BrandModelFieldOfString | undefined;
    state?: BrandModelFieldOfString | undefined;
    zipCode?: BrandModelFieldOfString | undefined;
    country?: BrandModelFieldOfString | undefined;
    email?: BrandModelFieldOfString | undefined;
    website?: BrandModelFieldOfString | undefined;
    isPubliclyTraded?: BrandModelFieldOfBoolean | undefined;
    stockSymbol?: BrandModelFieldOfString | undefined;
    stockExchange?: BrandModelFieldOfStockExchange | undefined;
    altBusinessId?: BrandModelFieldOfString | undefined;
    altBusinessIdType?: BrandModelFieldOfAltBusinessIdType | undefined;
    primaryContactFirstName?: BrandModelFieldOfString | undefined;
    primaryContactLastName?: BrandModelFieldOfString | undefined;
    linkForTextMessagingOptInTermsOfService?: BrandModelFieldOfString | undefined;
    businessContactEmail?: BrandModelFieldOfString | undefined;
}

export enum BrandStatus {
    None = 0,
    New = 1,
    Error = 2,
    CreationInProgress = 3,
    CreationError = 4,
    SuccessfullyCreated = 5,
}

export interface ErrorMessageContainer {
    errorMessage?: string | undefined;
}

export interface BrandModelFieldOfString extends ErrorMessageContainer {
    value?: string;
}

export interface BrandModelFieldOfBoolean extends ErrorMessageContainer {
    value: boolean;
}

export interface BrandModelFieldOfStockExchange extends ErrorMessageContainer {
    value: StockExchange;
}

export enum StockExchange {
    None = 0,
    Nasdaq = 1,
    Nyse = 2,
    Amex = 3,
    Amx = 4,
    Asx = 5,
    B3 = 6,
    Bme = 7,
    Bse = 8,
    Fra = 9,
    Icex = 10,
    Jpx = 11,
    Jse = 12,
    Krx = 13,
    Lon = 14,
    Nse = 15,
    Omx = 16,
    Sehk = 17,
    Sgx = 18,
    Sse = 19,
    Sto = 20,
    Swx = 21,
    Szse = 22,
    Tsx = 23,
    Twse = 24,
    Vse = 25,
    Other = 26,
}

export interface BrandModelFieldOfAltBusinessIdType extends ErrorMessageContainer {
    value: AltBusinessIdType;
}

export enum AltBusinessIdType {
    None = 0,
    Duns = 1,
    Giin = 2,
    Lei = 3,
}
